import './shared/RowActions.css';
import { PharmacySelect, PharmacyPagination, PharmacyDownloadDialog, PharmacyMetric, PharmacyTabs } from './shared/PharmacyUI';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography, CircularProgress, Tooltip, Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import './shared/ConsumoPaciente.css';

const FINANCIAMIENTOS = [
  { label:'TODOS',                  code:''   },
  { label:'CONTADO',                code:'01' },
  { label:'SIS',                    code:'03' },
  { label:'SOAT',                   code:'04' },
  { label:'OTROS CONVENIOS',        code:'06' },
  { label:'SALUDPOL',               code:'21' },
  { label:'INTERVENCION SANITARIA', code:'20' },
];
const TIPOS_DOC = [
  { label:'DNI',    value:'0' },
  { label:'FUA',    value:'1' },
  { label:'NOMBRE', value:'2' },
  { label:'TODOS',  value:'3' },
];
const fechaLocal = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const hoy = () => fechaLocal(new Date());
const haceUnMes = () => { const d = new Date(); d.setMonth(d.getMonth()-1); return fechaLocal(d); };
const fmtFecha = (s) => s ? new Date(s).toLocaleDateString('es-PE',{ day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '';
const fmtS     = (v) => `S/ ${Number(v||0).toLocaleString('es-PE',{ minimumFractionDigits:2 })}`;

const normalizarReceta = (r) => { const fields=Object.fromEntries(Object.entries(r).map(([k,v])=>[k.toLowerCase(),v])); return {...r,codigo:String(fields.codigo??'').trim(),clides:fields.clides||'',dni_clie:fields.dni_clie||'',nombre:fields.nombre||'',serie:fields.serie||'',correlativo:fields.correlativo||'',almcod:fields.almcod||'',vtafechreg:fields.vtafechreg,vtatotal:fields.vtatotal,fpDescripcion:fields.fpdescripcion||''}; };
const Sel = PharmacySelect;

const Paginacion = PharmacyPagination;

// ── Modal visor PDF — igual que ReporteConteo ─────────────────────────────────
const ModalPdfVisor = ({ open, onClose, pdfUrl, cargando, titulo, subtitulo, nombreDescarga }) => {
  if (!open) return null;
  return (
    <Box className="pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, zIndex:9999, bgcolor:'rgba(0,0,0,0.7)',
      display:'flex', alignItems:'center', justifyContent:'center', p:2, backdropFilter:'blur(4px)' }}
      onClick={()=>{ onClose(); }}>
      <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" onClick={e=>e.stopPropagation()}
        sx={{ bgcolor:IOS.surface, borderRadius:'20px', overflow:'hidden',
          width:'92vw', maxWidth:1100, height:'92vh',
          display:'flex', flexDirection:'column', boxShadow:'0 24px 60px rgba(0,0,0,0.4)' }}>

        {/* Header visor */}
        <Box className="pharmacy-layout" sx={{ px:2.5, pt:2, pb:1.5, borderBottom:`1px solid ${IOS.separator}`, flexShrink:0,
          display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <Box>
            <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>{titulo}</Typography>
            {subtitulo && <Typography sx={{ fontSize:'0.72rem', color:IOS.label2 }}>{subtitulo}</Typography>}
          </Box>
          <Box className="pharmacy-layout" sx={{ display:'flex', gap:1, alignItems:'center' }}>
            {pdfUrl && (
              <>
                {/* Descargar */}
                <Box className="pharmacy-layout" component="a" href={pdfUrl} download={nombreDescarga}
                  sx={{ height:32, px:1.5, borderRadius:'10px', border:`1px solid ${IOS.green}30`,
                    bgcolor:`${IOS.green}08`, cursor:'pointer', color:IOS.green, fontWeight:700,
                    fontSize:'0.78rem', textDecoration:'none', display:'flex', alignItems:'center',
                    gap:0.5, '&:hover':{ bgcolor:`${IOS.green}14` } }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2" strokeLinecap="round"><path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/></svg>
                  Descargar
                </Box>
                {/* Imprimir directo */}
                <Box className="pharmacy-layout pharmacy-action" component="button"
                  onClick={() => {
                    const iframe = document.getElementById('pdf-visor-frame');
                    if (iframe) { iframe.contentWindow.focus(); iframe.contentWindow.print(); }
                  }}
                  sx={{ height:32, px:1.5, borderRadius:'10px', border:`1px solid ${IOS.blue}30`,
                    bgcolor:`${IOS.blue}08`, cursor:'pointer', display:'flex', alignItems:'center',
                    gap:0.5, '&:hover':{ bgcolor:`${IOS.blue}14` } }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:700, color:IOS.blue }}>Imprimir</Typography>
                </Box>
              </>
            )}
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={onClose}
              sx={{ width:30, height:30, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA',
                cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center',
                '&:hover':{ bgcolor:'#D1D1D6' } }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </Box>
          </Box>
        </Box>

        {/* Contenido */}
        <Box sx={{ flex:1, overflow:'hidden', bgcolor:'#525659' }}>
          {cargando
            ? <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', gap:2 }}>
                <CircularProgress sx={{ color:'white' }} />
                <Typography sx={{ color:'rgba(255,255,255,0.8)', fontSize:'0.85rem' }}>Generando reporte...</Typography>
              </Box>
            : pdfUrl
              ? <iframe id="pdf-visor-frame" src={pdfUrl}
                  style={{ width:'100%', height:'100%', border:'none' }} title="Reporte PDF" />
              : <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
                  <Typography sx={{ color:'rgba(255,255,255,0.6)' }}>No se pudo generar el reporte</Typography>
                </Box>
          }
        </Box>
      </Box>
    </Box>
  );
};

// ── Modal selector formato — ahora PDF abre visor, Excel descarga ─────────────
const ModalExportar = ({ open, onClose, total, onExportarExcel, onVerPdf, exportando }) => (<PharmacyDownloadDialog open={open} onClose={onClose} total={total} busy={exportando} options={[{fmt:'pdf',label:'Ver PDF',sub:'Previsualizar e imprimir',onClick:onVerPdf},{fmt:'excel',label:'Descargar Excel',onClick:onExportarExcel}]}/>);

const ModalDetalle = ({open,onClose,receta,detalle,cargando,error}) => <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="consumo-detail-title" PaperProps={{className:'consumo-detail-panel',sx:{borderRadius:'22px'}}}>
  <div className="consumo-detail-head"><div><span>DETALLE DE RECETA</span><h2 id="consumo-detail-title">{receta?.serie}-{receta?.correlativo}</h2><p>{receta?.nombre}</p></div><button type="button" className="consumo-close" aria-label="Cerrar detalle" onClick={onClose}>×</button></div>
  <div className="consumo-detail-body"><div className="consumo-patient"><div><small>PACIENTE</small><strong>{receta?.clides||'Paciente no informado'}</strong><span>Documento · {receta?.dni_clie||'No informado'}</span></div><div><small>FECHA DE ATENCIÓN</small><strong>{fmtFecha(receta?.vtafechreg)||'No informada'}</strong><span>{receta?.fpDescripcion||'Financiamiento no informado'}</span></div><div><small>IMPORTE DE LA RECETA</small><strong>{fmtS(receta?.vtatotal)}</strong><span>Almacén · {receta?.almcod||'No informado'}</span></div></div>
  {cargando?<Box sx={{py:6,textAlign:'center'}}><CircularProgress size={26}/></Box>:error?<div role="alert" className="consumo-error">{error}</div>:!detalle.length?<p className="consumo-empty">Esta receta no tiene detalle disponible.</p>:<><div className="consumo-detail-table"><table><thead><tr>{['Producto / código','Dispensado','Devuelto','Neto','Importe neto'].map(t=><th key={t}>{t}</th>)}</tr></thead><tbody>{detalle.map((d,i)=><tr key={i}><td><strong>{d.producto}</strong><small>{d.medCod} · {d.fM_medtip==='M'?'Medicamento':'Insumo'}</small></td><td>{d.cantidad_Vendida}</td><td>{d.cantidad_Devuelta}</td><td><strong>{d.cantidad_Neta}</strong></td><td>{fmtS(d.total_Neto)}</td></tr>)}</tbody></table></div><div className="consumo-detail-total"><span>{detalle.length} productos · Descontadas las devoluciones</span><strong>Total neto {fmtS(detalle.reduce((sum,d)=>sum+Number(d.total_Neto||0),0))}</strong></div></>}
  </div></Dialog>;

const DIAS_SEMANA = ['D','L','M','M','J','V','S'];
const MESES_LARGO = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const parseYMD = (s) => { if(!s) return new Date(); const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };

const DatePickerIOS = ({ value, onChange, w='100%' }) => {
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);
  const ref = useRef(null);
  const popupRef = useRef(null);
  const selDate = value ? parseYMD(value) : null;
  const [viewMonth, setViewMonth] = useState(selDate ? selDate.getMonth() : new Date().getMonth());
  const [viewYear, setViewYear] = useState(selDate ? selDate.getFullYear() : new Date().getFullYear());

  useEffect(() => {
    const h = e => {
      const dentroTrigger = ref.current && ref.current.contains(e.target);
      const dentroPopup = popupRef.current && popupRef.current.contains(e.target);
      if (!dentroTrigger && !dentroPopup) setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const handleOpen = () => {
    if (ref.current) setRect(ref.current.getBoundingClientRect());
    if (selDate) { setViewMonth(selDate.getMonth()); setViewYear(selDate.getFullYear()); }
    setOpen(v=>!v);
  };

  const cambiarMes = (delta) => {
    let m = viewMonth + delta, y = viewYear;
    if (m < 0) { m = 11; y--; } else if (m > 11) { m = 0; y++; }
    setViewMonth(m); setViewYear(y);
  };

  const elegirDia = (dia) => { onChange(toYMD(new Date(viewYear, viewMonth, dia))); setOpen(false); };

  const hoyD = new Date();
  const primerDiaSemana = new Date(viewYear, viewMonth, 1).getDay();
  const totalDias = new Date(viewYear, viewMonth+1, 0).getDate();
  const celdas = [...Array(primerDiaSemana).fill(null), ...Array.from({length:totalDias},(_,i)=>i+1)];
  const labelFecha = selDate ? `${String(selDate.getDate()).padStart(2,'0')}/${String(selDate.getMonth()+1).padStart(2,'0')}/${selDate.getFullYear()}` : '';

  return (
    <Box ref={ref} sx={{ position:'relative', width:w }}>
      <Box className="pharmacy-layout" onClick={handleOpen}
        sx={{ height:34, px:1.2, display:'flex', alignItems:'center', gap:0.8,
          border:`1px solid ${open?IOS.blue:IOS.separator}`, borderRadius:'8px',
          bgcolor:IOS.surface, cursor:'pointer', userSelect:'none',
          boxShadow:open?`0 0 0 3px ${IOS.blue}18`:'none', transition:'all 0.15s', boxSizing:'border-box' }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <Typography sx={{ fontSize:'0.8rem', color:IOS.label, flex:1, whiteSpace:'nowrap' }}>{labelFecha}</Typography>
      </Box>

      {open && rect && ReactDOM.createPortal(
        <Box ref={popupRef} sx={{ position:'fixed', top:rect.bottom+4, left:rect.left, zIndex:99999,
          bgcolor:IOS.surface, border:`1px solid ${IOS.separator}`, borderRadius:'14px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.16)', width:260, p:1.5 }}>

          <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>cambiarMes(-1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            </Box>
            <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:IOS.label }}>{MESES_LARGO[viewMonth]} {viewYear}</Typography>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>cambiarMes(1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </Box>
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', mb:0.5 }}>
            {DIAS_SEMANA.map((d,i)=>(<Typography key={i} sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textAlign:'center' }}>{d}</Typography>))}
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'2px' }}>
            {celdas.map((dia,i)=>{
              if (dia===null) return <Box key={i} />;
              const esHoy = dia===hoyD.getDate() && viewMonth===hoyD.getMonth() && viewYear===hoyD.getFullYear();
              const esSel = selDate && dia===selDate.getDate() && viewMonth===selDate.getMonth() && viewYear===selDate.getFullYear();
              return (
                <Box className="pharmacy-layout" key={i} onClick={()=>elegirDia(dia)}
                  sx={{ height:30, display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'8px', cursor:'pointer',
                    bgcolor:esSel?IOS.blue:'transparent',
                    border:esHoy&&!esSel?`1.5px solid ${IOS.blue}`:'none' }}>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:esSel?700:500, color:esSel?'white':IOS.label }}>{dia}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>, document.body
      )}
    </Box>
  );
};

const KpiCard = PharmacyMetric;

const TipoPill = ({ tipo }) => (
  <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.4, px:0.8, py:0.2, borderRadius:'20px',
    bgcolor:tipo==='M'?'#EBF5FF':'#FFF5E6', border:`1px solid ${tipo==='M'?'#BFDBFE':'#FED7AA'}` }}>
    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:tipo==='M'?IOS.blue:IOS.orange }}>
      {tipo==='M'?'Med':'Ins'}
    </Typography>
  </Box>
);

// ── Celda tfoot compartida ────────────────────────────────────────────────────
const TF = ({ children, right, colSpan }) => (
  <td colSpan={colSpan} style={{ padding:'9px 12px', textAlign:right?'right':'left',
    fontSize:'0.72rem', fontWeight:700, color:IOS.label2,
    borderTop:`2px solid ${IOS.separator}`, backgroundColor:IOS.bg }}>
    {children}
  </td>
);

const ConsumoPaciente = ({ modulo = 'seguros' }) => {
  const navigate = useNavigate();
  const user     = authService.getCurrentUser();
  const ueId     = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;

  const idEstabUsuario = String(user?.idEstablecimiento||user?.IdEstablecimiento||0);
  const [privConsumoPac, setPrivConsumoPac] = useState(null);

  useEffect(()=>{
    api.get('/dashboard/permisos').then(r=>{
      if(r.data.success){
        const op = r.data.opciones.find(o=>(o.permiso||'').toLowerCase().includes('consumopac'));
        setPrivConsumoPac(op?.privilegio||'Solo lectura');
      } else setPrivConsumoPac('Solo lectura');
    }).catch(()=>setPrivConsumoPac('Solo lectura'));
  },[]);

  const esTOTAL    = privConsumoPac === 'Total';
  const esPARCIAL  = privConsumoPac === 'Lectura/Escritura';
  const esSoloLect = privConsumoPac === 'Solo lectura';

  const [tab, setTab]               = useState(0);
  const [ipress, setIpress]         = useState([]);
  const [loadIP, setLoadIP]         = useState(true);
  const [ipressSel, setIpressSel]   = useState('');
  const [fechaIni, setFechaIni]     = useState(hoy());
  const [fechaFin, setFechaFin]     = useState(hoy());
  const [finan, setFinan]           = useState('TODOS');
  const [tipodoc, setTipodoc]       = useState('0');
  const [documento, setDocumento]   = useState('');
  const [buscando, setBuscando]     = useState(false);
  const [recetas, setRecetas]       = useState([]);
  const [paciente, setPaciente]     = useState(null);
  const [idEstudio, setIdEstudio]   = useState(null);
  const [filtrosEst, setFiltrosEst] = useState(null);
  const mutationLock=useRef(false);
  const searchSeq=useRef(0);
  const detailSeq=useRef(0);
  const resultSeq=useRef(0);
  const [searchContext,setSearchContext]=useState(null);
  const [notice,setNotice]=useState('');
  const [recentlyAdded,setRecentlyAdded]=useState(new Set());
  const [detailError,setDetailError]=useState('');
  const [error, setError]           = useState('');
  const [estudios, setEstudios]     = useState([]);
  const [loadEst, setLoadEst]       = useState(false);
  const [estIni, setEstIni]         = useState(haceUnMes());
  const [estFin, setEstFin]         = useState(hoy());
  const [filtroEst, setFiltroEst]   = useState('');
  const [pgEst, setPgEst]           = useState(1);
  const [rppEst, setRppEst]         = useState(25);
  const [mIni, setMIni]             = useState(hoy());
  const [mFin, setMFin]             = useState(hoy());
  const [mFinan, setMFinan]         = useState('TODOS');
  const [mIpress, setMIpress]       = useState('');
  const [masivo, setMasivo]         = useState([]);
  const [loadMas, setLoadMas]       = useState(false);
  const [buscoMas, setBuscoMas]     = useState(false);
  const [pgMas, setPgMas]           = useState(1);
  const [rppMas, setRppMas]         = useState(50);
  const [fMasTxt, setFMasTxt]       = useState('');
  const [fMasFecha, setFMasFecha]   = useState('');
  const [fMasFp, setFMasFp]         = useState('TODOS');
  const [fMasFarm, setFMasFarm]     = useState('TODOS');
  const [guardando, setGuardando]   = useState(false);
  const [agregados, setAgregados]   = useState(new Set());
  const [vista, setVista]           = useState('resumido');
  const [resumido, setResumido]     = useState([]);
  const [detallado, setDetallado]   = useState([]);
  const [loadRes, setLoadRes]       = useState(false);
  const [pgRes, setPgRes]           = useState(1);
  const [rppRes, setRppRes]         = useState(50);
  const [pgDet, setPgDet]           = useState(1);
  const [rppDet, setRppDet]         = useState(50);
  const [modalExp, setModalExp]     = useState(false);
  const [exportando, setExportando] = useState(false);
  const [modalDet, setModalDet]     = useState(false);
  const [detalleRec, setDetalleRec] = useState([]);
  const [loadDet, setLoadDet]       = useState(false);
  const [recetaSel, setRecetaSel]   = useState(null);

  // ── Estado visor PDF ──────────────────────────────────────────────────────
  const [modalPdf, setModalPdf]     = useState(false);
  const [pdfUrl, setPdfUrl]         = useState(null);
  const [cargPdf, setCargPdf]       = useState(false);

  const inputRef = useRef(null);
  const handleLogout = () => { authService.logout(); navigate(`/${modulo}`); };

  useEffect(() => {
    if(!privConsumoPac) return;
    api.get(`/seguros/ConsumoPaciente/listar-ipress?ueId=${ueId}`)
      .then(r=>{
        if(r.data.success&&r.data.data.length){
          const lista = r.data.data;
          const mi = lista.find(ip=>String(ip.id_establecimiento)===idEstabUsuario)||lista[0];
          if(privConsumoPac==='Total'){
            setIpress(lista);
            setIpressSel(mi.id_establecimiento);
          } else {
            setIpress([mi]);
            setIpressSel(mi.id_establecimiento);
          }
          setMIpress(mi.id_establecimiento);
        }
      })
      .catch(console.error).finally(()=>setLoadIP(false));
  }, [ueId, privConsumoPac]);

  useEffect(() => { if(tab===1) setTimeout(()=>inputRef.current?.focus(),100); }, [tab]);

  const buscarRecetas = useCallback(async () => {
    if(mutationLock.current) return;
    if(!ipressSel || fechaIni>fechaFin){setError('Selecciona una IPRESS y un rango de fechas válido.');return;}
    if(!documento.trim()&&tipodoc!=='3'){setError('Ingresa el dato del paciente que deseas buscar.');return;}
    const request=++searchSeq.current;
    const context={fechaIni,fechaFin,finan,ipressSel,tipodoc,documento:documento.trim()};
    setBuscando(true);setRecetas([]);setSearchContext(null);setError('');setNotice('');
    try{
      const r=await api.get('/seguros/ConsumoPaciente/buscar-recetas',{params:{tipo:tipodoc,dni:context.documento,inicio:fechaIni,fin:fechaFin,finan:FINANCIAMIENTOS.find(f=>f.label===finan)?.code??'',ipress:ipressSel}});
      if(request!==searchSeq.current)return;
      if(!r.data.success)throw new Error();
      const rows=(r.data.data||[]).map(normalizarReceta);setRecetas(rows);setSearchContext(context);
      if(!rows.length)setNotice('No se encontraron recetas con estos filtros.');
    }catch(e){if(request===searchSeq.current)setError('No se pudo completar la búsqueda. Intenta nuevamente.');}
    finally{if(request===searchSeq.current)setBuscando(false);}
  },[documento,tipodoc,fechaIni,fechaFin,finan,ipressSel]);

  const verDetalle = async receta => {
    const request=++detailSeq.current;
    setRecetaSel(receta);setModalDet(true);setLoadDet(true);setDetalleRec([]);setDetailError('');
    try{const r=await api.get('/seguros/ConsumoPaciente/detalle-receta',{params:{codigo:receta.codigo,ipress:receta.almcod}});
      if(request!==detailSeq.current)return;
      if(!r.data.success)throw new Error();setDetalleRec(r.data.data||[]);
    }catch(e){if(request===detailSeq.current)setDetailError('No se pudo cargar el detalle. Cierra y vuelve a intentarlo.');}
    finally{if(request===detailSeq.current)setLoadDet(false);}
  };

  const crearEstudio = async () => {
    if(!searchContext)throw new Error('Busca las recetas primero.');
    const {fechaIni,fechaFin,finan,ipressSel,tipodoc,documento}=searchContext;
    const r = await api.post('/seguros/ConsumoPaciente/crear-estudio', {
      idUsuario:user?.idUser||user?.IdUser||1,
      formaPago:FINANCIAMIENTOS.find(f=>f.label===finan)?.code??'',
      fechaInicio:fechaIni, fechaFin, ipress:ipressSel, tipodoc, documento:documento.trim(),
    });
    if(r.data.success){
      setIdEstudio(r.data.idEstudio);
      setFiltrosEst({ fechaIni, fechaFin, finan });
      const identities=new Set(recetas.map(x=>x.dni_clie+'|'+x.clides));
      setPaciente(identities.size===1?{nombre:recetas[0]?.clides,dni:recetas[0]?.dni_clie}:null);
      return r.data.idEstudio;
    }
    throw new Error('No se pudo crear estudio');
  };

  const cargarResultados = async (id) => {
    const request=++resultSeq.current;
    setLoadRes(true);
    try {
      const [rR,rD] = await Promise.all([
        api.get(`/seguros/ConsumoPaciente/resultado-resumido?idEstudio=${id}`),
        api.get(`/seguros/ConsumoPaciente/resultado-detallado?idEstudio=${id}`),
      ]);
      if(request!==resultSeq.current)return;
      if(!rR.data.success||!rD.data.success)throw new Error();
      if(rR.data.success) setResumido(rR.data.data);
      if(rD.data.success){
        setDetallado(rD.data.data);
        setAgregados(new Set(rD.data.data.map(x=>String(x.codigo??'').trim()).filter(Boolean)));
      }
      setPgRes(1); setPgDet(1);
    } catch(e){ console.error(e); if(request===resultSeq.current)setError('No se pudieron cargar los resultados del estudio.'); } finally { if(request===resultSeq.current)setLoadRes(false); }
  };

  const agregarReceta = async (receta) => {
    if(esSoloLect||mutationLock.current||buscando||!searchContext||!receta.codigo||agregados.has(receta.codigo)) return;
    mutationLock.current=true;setError('');setNotice('');
    setGuardando(true);
    try {
      let eid=idEstudio; if(!eid) eid=await crearEstudio();
      const response=await api.post('/seguros/ConsumoPaciente/agregar-receta', { idEstudio:eid, codigo:receta.codigo });
      if(!response.data.success)throw new Error();
      setAgregados(prev=>new Set([...prev, receta.codigo]));
      setRecentlyAdded(new Set([receta.codigo]));
      await cargarResultados(eid); setNotice('Receta añadida. Puedes seguir seleccionando o abrir el estudio.');
    } catch(e){ console.error(e); setError('No se pudo agregar la receta al estudio.'); } finally { mutationLock.current=false;setGuardando(false); }
  };

  const agregarTodas = async () => {
    if(esSoloLect||mutationLock.current||buscando||!searchContext)return;
    const pending=recetas.filter(r=>r.codigo&&!agregados.has(r.codigo));if(!pending.length)return;
    mutationLock.current=true;setGuardando(true);setError('');setNotice('');let completed=0;let eid=idEstudio;
    try{if(!eid)eid=await crearEstudio();
      for(const receta of pending){const r=await api.post('/seguros/ConsumoPaciente/agregar-receta',{idEstudio:eid,codigo:receta.codigo});if(!r.data.success)throw new Error();completed++;setAgregados(prev=>new Set([...prev,receta.codigo]));setRecentlyAdded(prev=>new Set([...prev,receta.codigo]));}
      await cargarResultados(eid);setNotice(completed+' recetas añadidas al estudio.');
    }catch(e){if(eid)await cargarResultados(eid);setError('Se añadieron '+completed+' de '+pending.length+' recetas. Revisa el estudio antes de continuar.');}
    finally{mutationLock.current=false;setGuardando(false);}
  };

  const quitarReceta = async (codigo) => {
    if (esSoloLect || mutationLock.current || !idEstudio || !codigo) return;
    mutationLock.current=true;setError('');setNotice('');
    setGuardando(true);
    try {
      const response=await api.post('/seguros/ConsumoPaciente/quitar-receta', { idEstudio, codigo });
      if(!response.data.success)throw new Error();
      setAgregados(prev=>{ const n = new Set(prev); n.delete(codigo); return n; });
      await cargarResultados(idEstudio);setNotice('Receta retirada del estudio. La receta original se conserva.');
    } catch(e){ console.error(e); setError('No se pudo quitar la receta del estudio.'); }
    finally { mutationLock.current=false;setGuardando(false); }
  };

  const resetear = () => {
    if(mutationLock.current)return;
    searchSeq.current++;resultSeq.current++;setBuscando(false);setSearchContext(null);setNotice('');setError('');
    setTab(1); setIdEstudio(null); setFiltrosEst(null); setRecetas([]); setPaciente(null);
    setResumido([]); setDetallado([]); setDocumento(''); setAgregados(new Set());
    if(pdfUrl)URL.revokeObjectURL(pdfUrl);setPdfUrl(null);
    setTimeout(()=>inputRef.current?.focus(),100);
  };

  // ── Ver PDF en visor ──────────────────────────────────────────────────────
  const verPdf = async () => {
    if (!idEstudio || cargPdf) return;
    setModalExp(false);
    setPdfUrl(null);
    setCargPdf(true);
    setModalPdf(true);
    try {
      const r = await api.get('/seguros/ConsumoPaciente/exportar-pdf', {
        params:{ idEstudio, tipo:vista }, responseType:'blob'
      });
      const url = URL.createObjectURL(new Blob([r.data], { type:'application/pdf' }));
      setPdfUrl(url);
    } catch(e){ console.error(e); setModalPdf(false); setError('No se pudo generar el PDF.'); }
    finally { setCargPdf(false); }
  };

  // ── Exportar Excel (descarga directa) ─────────────────────────────────────
  const exportarExcel = async () => {
    if (!idEstudio || exportando) return;
    setExportando(true);
    try {
      const r = await api.get('/seguros/ConsumoPaciente/exportar-excel', {
        params:{ idEstudio, tipo:vista }, responseType:'blob'
      });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([r.data], { type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      a.download = `ConsumoP_${paciente?.dni||'reporte'}_${vista}.xlsx`;
      a.click(); URL.revokeObjectURL(a.href);
      setModalExp(false);
    } catch(e){ console.error(e); setError('No se pudo generar el Excel.'); } finally { setExportando(false); }
  };

  const closePdf = () => {
    setModalPdf(false);
    if (pdfUrl) { URL.revokeObjectURL(pdfUrl); setPdfUrl(null); }
  };

  // ── Estudios guardados ────────────────────────────────────────────────────
  const cargarEstudios = useCallback(async () => {
    setLoadEst(true);
    try {
      const r = await api.get('/seguros/ConsumoPaciente/listar-estudios', {
        params:{ inicio:estIni, fin:estFin, verTodos:esTOTAL }
      });
      if(r.data.success){ setEstudios(r.data.data); setPgEst(1); }
    } catch(e){ console.error(e); setError('No se pudo cargar la lista de estudios.'); }
    finally { setLoadEst(false); }
  }, [esTOTAL, estIni, estFin]);

  const estudiosFiltrados = filtroEst.trim()
    ? estudios.filter(e2 =>
        (e2.dni||'').includes(filtroEst.trim()) ||
        (e2.paciente||'').toLowerCase().includes(filtroEst.trim().toLowerCase()))
    : estudios;
  const estPag = estudiosFiltrados.slice((pgEst-1)*rppEst, pgEst*rppEst);

  useEffect(()=>{ if(tab===0 && privConsumoPac) cargarEstudios(); }, [tab, privConsumoPac, cargarEstudios]);

  const abrirEstudio = async (est) => {
    if(mutationLock.current)return;
    searchSeq.current++;setBuscando(false);setRecetas([]);setSearchContext(null);setResumido([]);setDetallado([]);setNotice('');setError('');
    setIdEstudio(est.idEstudio);
    setFiltrosEst({
      fechaIni: est.fechaI, fechaFin: est.fechaF,
      finan: FINANCIAMIENTOS.find(f=>f.code===(est.formaPago||''))?.label || est.formaPago || 'TODOS',
    });
    setPaciente({ nombre:est.paciente, dni:est.dni });
    setAgregados(new Set());
    setTab(2);
    await cargarResultados(est.idEstudio);
  };

  // ── Consulta masiva ───────────────────────────────────────────────────────
  const buscarMasivo = useCallback(async () => {
    const lim = parseYMD(mIni); lim.setMonth(lim.getMonth()+3);
    if (parseYMD(mFin) > lim) { setError('El período máximo de consulta es de 3 meses.'); return; }
    setLoadMas(true); setBuscoMas(true); setMasivo([]); setError('');
    try {
      const r = await api.get('/seguros/ConsumoPaciente/consulta-masiva', {
        params:{ inicio:mIni, fin:mFin, finan:FINANCIAMIENTOS.find(f=>f.label===mFinan)?.code??'', ipress:mIpress }
      });
      if(r.data.success){
        setMasivo(r.data.data); setPgMas(1);
        setFMasTxt(''); setFMasFecha(''); setFMasFp('TODOS'); setFMasFarm('TODOS');
      }
    } catch(e){ console.error(e); setError('No se pudo completar la consulta masiva.'); }
    finally { setLoadMas(false); }
  }, [mIni, mFin, mFinan, mIpress]);

  const exportarMasivoExcel = async () => {
    if (masivo.length===0 || exportando) return;
    setExportando(true);
    try {
      const r = await api.get('/seguros/ConsumoPaciente/exportar-masivo-excel', {
        params:{ inicio:mIni, fin:mFin, finan:FINANCIAMIENTOS.find(f=>f.label===mFinan)?.code??'', ipress:mIpress },
        responseType:'blob'
      });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([r.data], { type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      a.download = `ConsumoMasivo_${mIni}_${mFin}.xlsx`;
      a.click(); URL.revokeObjectURL(a.href);
    } catch(e){ console.error(e); setError('No se pudo generar el Excel masivo.'); }
    finally { setExportando(false); }
  };

  const rangoMasivoLargo = (parseYMD(mFin) - parseYMD(mIni)) / 86400000 > 62;
  const limMasivo = (()=>{ const d = parseYMD(mIni); d.setMonth(d.getMonth()+3); return parseYMD(mFin) > d; })();
  const fpsMasivo   = ['TODOS', ...new Set(masivo.map(r=>r.formaPago).filter(Boolean))];
  const farmsMasivo = ['TODOS', ...new Set(masivo.map(r=>r.farmacia).filter(Boolean))];
  const fechaMasFmt = fMasFecha ? fMasFecha.split('-').reverse().join('/') : '';
  const txtMas = fMasTxt.trim().toLowerCase();
  const masivoFiltrado = masivo.filter(r =>
    (!txtMas
      || (r.dni||'').toLowerCase().includes(txtMas)
      || (r.paciente||'').toLowerCase().includes(txtMas)
      || (r.comprobante||'').toLowerCase().includes(txtMas))
    && (!fechaMasFmt || (r.fecha||'').startsWith(fechaMasFmt))
    && (fMasFp==='TODOS' || r.formaPago===fMasFp)
    && (fMasFarm==='TODOS' || r.farmacia===fMasFarm)
  );
  const totMasivo = {
    cantidad: masivoFiltrado.reduce((s,r)=>s+Number(r.cantidad||0),0),
    importe:  masivoFiltrado.reduce((s,r)=>s+Number(r.importe||0),0),
  };
  const masPag = masivoFiltrado.slice((pgMas-1)*rppMas, pgMas*rppMas);

  // ── Totales ───────────────────────────────────────────────────────────────
  const totalGeneral  = resumido.reduce((s,r)=>s+Number(r.total_Neto||0),0);
  const totalMeds     = resumido.filter(r=>r.fM_medtip==='M').reduce((s,r)=>s+Number(r.total_Neto||0),0);
  const totalInsumos  = resumido.filter(r=>r.fM_medtip==='I').reduce((s,r)=>s+Number(r.total_Neto||0),0);
  const cantRecetas   = agregados.size;
  const cantMeds      = resumido.filter(r=>r.fM_medtip==='M').length;
  const cantInsumos   = resumido.filter(r=>r.fM_medtip==='I').length;
  const totalExp      = vista==='resumido'?resumido.length:detallado.length;
  const resPag        = resumido.slice((pgRes-1)*rppRes, pgRes*rppRes);
  const detPag        = detallado.slice((pgDet-1)*rppDet, pgDet*rppDet);
  const recetasEstudio = [...new Map(detallado.map(r=>[r.codigo, { codigo:r.codigo, comprobante:`${r.serie}-${r.correlativo}` }])).values()];

  // Totales columnas resumido
  const totResumido = {
    vendida:  resumido.reduce((s,r)=>s+Number(r.cantidad_Vendida||0),0),
    devuelta: resumido.reduce((s,r)=>s+Number(r.cantidad_Devuelta||0),0),
    neta:     resumido.reduce((s,r)=>s+Number(r.cantidad_Neta||0),0),
    total:    resumido.reduce((s,r)=>s+Number(r.total_Neto||0),0),
  };
  // Totales columnas detallado
  const totDetallado = {
    vendida:  detallado.reduce((s,r)=>s+Number(r.cantidad_Vendida||0),0),
    devuelta: detallado.reduce((s,r)=>s+Number(r.cantidad_Devuelta||0),0),
    neta:     detallado.reduce((s,r)=>s+Number(r.cantidad_Neta||0),0),
    total:    detallado.reduce((s,r)=>s+Number(r.total_Neto||0),0),
  };

  return (
    <>
      <Box className="pharmacy-page consumo-page" sx={{ minHeight:'100vh', bgcolor:IOS.bg }}>
        <HeaderIOS titulo="Consumo Paciente"
          subtitulo={modulo==='farmacia'?'Farmacia':'Seguros'}
          onHome={()=>navigate(`/${modulo}`)} onLogout={handleLogout}
          nombreCompleto={user?.nombreCompleto||user?.usuario||''}
          avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />

        {/* Tabs */}
        <Box className="pharmacy-tabs-row"><PharmacyTabs value={tab} onChange={v=>{if(!mutationLock.current)setTab(v);}} options={[{label:'Estudios Guardados'},{label:'Buscar Recetas'},{label:'Detalle Estudio',badge:!!idEstudio},...(esTOTAL?[{label:'Consulta Masiva'}]:[])]}/></Box>

        <Box className="pharmacy-content" sx={{ maxWidth:1600, mx:'auto', px:{ xs:1.5, sm:2.6 }, pt:2.5, pb:6 }}>

          <header className="consumo-heading"><span>Consumo · {modulo==='farmacia'?'Farmacia':'Seguros'}</span><h1>{['Seguimiento del consumo','Encuentra las recetas del paciente','El consumo, en detalle','Una mirada al consumo'][tab]}</h1><p>{['Consulta tus estudios y retoma el seguimiento de cada paciente.','Revisa el paciente y sus atenciones; añade las recetas que necesitas comparar.','Revisa las recetas seleccionadas, sus devoluciones y el importe neto.','Explora las atenciones por establecimiento, fecha y financiamiento.'][tab]}</p></header>
          {notice&&<div className="consumo-notice" role="status">{notice}</div>}
          {idEstudio&&(tab===1||tab===2)&&<div className="consumo-study-bar"><div><strong>{agregados.size} recetas en el estudio</strong><span>{guardando?'Guardando cambios…':'Los cambios se guardan automáticamente.'}</span></div><button type="button" disabled={guardando} onClick={()=>setTab(tab===1?2:1)}>{tab===1?'Ver estudio':'Añadir más recetas'} →</button></div>}
          {error && (
            <Box className="pharmacy-layout" sx={{ mb:2, px:2, py:1.2, borderRadius:'12px', bgcolor:'#FEF2F2', border:'1px solid #FECACA',
              display:'flex', alignItems:'center', justifyContent:'space-between', gap:1 }}>
              <Typography sx={{ fontSize:'0.8rem', color:'#B91C1C', fontWeight:600 }}>{error}</Typography>
              <Box className="pharmacy-action" component="button" onClick={()=>setError('')}
                sx={{ border:'none', bgcolor:'transparent', cursor:'pointer', color:'#B91C1C', fontWeight:700, fontSize:'0.85rem', p:0 }}>✕</Box>
            </Box>
          )}

          {/* ══ TAB 0: Estudios Guardados ══ */}
          {tab===0 && (
            <Box>
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2.5,
                boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2.5 }}>
                <Box className="pharmacy-layout" sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-end' }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Creados entre</Typography>
                    <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1, width:{ xs:'100%', sm:'auto' } }}>
                      <DatePickerIOS value={estIni} onChange={setEstIni} w={{ xs:'calc(50% - 4px)', sm:130 }} />
                      <DatePickerIOS value={estFin} onChange={setEstFin} w={{ xs:'calc(50% - 4px)', sm:130 }} />
                    </Box>
                  </Box>
                  <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3, flex:1, minWidth:{ xs:'100%', sm:220 } }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Filtrar resultados</Typography>
                    <input type="text" placeholder="DNI o nombre del paciente..."
                      value={filtroEst} onChange={e=>{setFiltroEst(e.target.value);setPgEst(1);}}
                      style={{ height:34, padding:'0 10px', border:`1px solid ${IOS.separator}`, borderRadius:8,
                        fontSize:'0.8rem', color:IOS.label, backgroundColor:IOS.surface, outline:'none', fontFamily:'inherit' }}
                      onFocus={e=>e.target.style.borderColor=IOS.blue}
                      onBlur={e=>e.target.style.borderColor=IOS.separator} />
                  </Box>
                  <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5, pb:0.2 }}>
                    <Typography sx={{ fontSize:'0.75rem', color:IOS.label2, whiteSpace:'nowrap' }}>
                      {loadEst ? 'Cargando…' : `${estudiosFiltrados.length} de ${estudios.length}`}
                    </Typography>
                    <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cargarEstudios} disabled={loadEst}
                      sx={{ height:32, px:1.5, borderRadius:'10px', border:`1px solid ${IOS.separator}`, bgcolor:IOS.surface,
                        cursor:loadEst?'wait':'pointer', display:'flex', alignItems:'center', gap:0.6, '&:hover':{ bgcolor:IOS.bg } }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2" strokeLinecap="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 3 21 9 15 9"/></svg>
                      <Typography sx={{ fontSize:'0.75rem', fontWeight:700, color:IOS.label }}>Actualizar</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {loadEst && <Box sx={{ py:10, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}

              {!loadEst && estudiosFiltrados.length===0 && (
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                  <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, mb:0.5 }}>
                    {estudios.length===0?'Sin estudios en este rango':'Sin coincidencias'}
                  </Typography>
                  <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>
                    {estudios.length===0?'Amplía el rango de fechas o crea uno desde Buscar Recetas':'Ningún estudio coincide con ese DNI o nombre'}
                  </Typography>
                </Box>
              )}

              {!loadEst && estudiosFiltrados.length>0 && (
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                  {/* Móvil — cards */}
                  <Box sx={{ display:{ xs:'block', md:'none' } }}>
                    {estPag.map((e2,i)=>(
                      <Box key={i} onClick={()=>abrirEstudio(e2)}
                        sx={{ p:2, borderBottom:`1px solid ${IOS.separator}`, cursor:'pointer', '&:active':{ bgcolor:IOS.bg } }}>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:0.8 }}>
                          <Box sx={{ minWidth:0 }}>
                            <Typography sx={{ fontWeight:700, fontSize:'0.85rem', color:IOS.blue }}>{e2.paciente||'—'}</Typography>
                            <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, fontFamily:'monospace' }}>DNI: {e2.dni||'—'}</Typography>
                          </Box>
                          <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap', flexShrink:0 }}>{e2.fechaCreacion}</Typography>
                        </Box>
                        <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:0.8, flexWrap:'wrap', mb:0.8 }}>
                          <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px', bgcolor:`${IOS.blue}10`, border:`1px solid ${IOS.blue}25` }}>
                            <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue }}>
                              {FINANCIAMIENTOS.find(f=>f.code===(e2.formaPago||''))?.label||e2.formaPago||'TODOS'}
                            </Typography>
                          </Box>
                          <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>{e2.fechaI} — {e2.fechaF}</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, mb:0.8, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{e2.ipressNombre||e2.ipress}</Typography>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                          <Typography sx={{ fontSize:'0.7rem', color:IOS.label2 }}>{e2.cantRecetas} receta{e2.cantRecetas===1?'':'s'} · {e2.usuario}</Typography>
                          <Typography sx={{ fontSize:'0.85rem', fontWeight:800, color:IOS.label }}>S/ {Number(e2.total||0).toFixed(2)}</Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  {/* Desktop — tabla */}
                  <Box sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem', minWidth:900 }}>
                      <thead>
                        <tr>
                          {['Creado','Paciente','DNI','Período','Financ.','IPRESS','Recetas','Total','Usuario',''].map((h,i)=>(
                            <th key={i} style={{ padding:'9px 12px', textAlign:h==='Recetas'||h==='Total'?'right':'left',
                              fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em', textTransform:'uppercase',
                              backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {estPag.map((e2,i)=>(
                          <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface, cursor:'pointer', transition:'background 0.1s' }}
                            onClick={()=>abrirEstudio(e2)}
                            onMouseEnter={ev=>ev.currentTarget.style.backgroundColor=IOS.bg}
                            onMouseLeave={ev=>ev.currentTarget.style.backgroundColor=IOS.surface}>
                            <td style={{ padding:'9px 12px', fontSize:'0.7rem', color:IOS.label2, whiteSpace:'nowrap' }}>{e2.fechaCreacion}</td>
                            <td style={{ padding:'9px 12px', fontWeight:600, color:IOS.label }}>{e2.paciente||'—'}</td>
                            <td style={{ padding:'9px 12px', fontFamily:'monospace', color:IOS.label2 }}>{e2.dni||'—'}</td>
                            <td style={{ padding:'9px 12px', fontSize:'0.7rem', color:IOS.label2, whiteSpace:'nowrap' }}>{e2.fechaI} — {e2.fechaF}</td>
                            <td style={{ padding:'9px 12px' }}>
                              <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px', bgcolor:`${IOS.blue}10`, border:`1px solid ${IOS.blue}25` }}>
                                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue }}>
                                  {FINANCIAMIENTOS.find(f=>f.code===(e2.formaPago||''))?.label||e2.formaPago||'TODOS'}
                                </Typography>
                              </Box>
                            </td>
                            <td style={{ padding:'9px 12px', maxWidth:180 }}>
                              <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:180, fontSize:'0.7rem', color:IOS.label }}>{e2.ipressNombre||e2.ipress}</span>
                            </td>
                            <td style={{ padding:'9px 12px', textAlign:'right', color:IOS.label }}>{e2.cantRecetas}</td>
                            <td style={{ padding:'9px 12px', textAlign:'right', fontWeight:700, color:IOS.label }}>{Number(e2.total||0).toFixed(2)}</td>
                            <td style={{ padding:'9px 12px', fontSize:'0.7rem', color:IOS.label2 }}>{e2.usuario}</td>
                            <td style={{ padding:'9px 8px', textAlign:'center', width:40 }}>
                              <Box sx={{ width:28, height:28, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'inline-flex', alignItems:'center', justifyContent:'center' }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2.2" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
                              </Box>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                  <Paginacion total={estudiosFiltrados.length} pagina={pgEst} setPagina={setPgEst} rpp={rppEst} setRpp={setRppEst} />
                </Box>
              )}
            </Box>
          )}

          {/* ══ TAB 1: Buscar Recetas ══ */}
          {tab===1 && (
            <Box>
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2.5,
                boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2.5 }}>
                <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-end' }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Período</Typography>
                    <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1 }}>
                      <DatePickerIOS value={fechaIni} onChange={setFechaIni} w={{ xs:'calc(50% - 4px)', sm:130 }} />
                      <DatePickerIOS value={fechaFin} onChange={setFechaFin} w={{ xs:'calc(50% - 4px)', sm:130 }} />
                    </Box>
                  </Box>
                  {esTOTAL
                    ? <Sel label="IPRESS" value={ipressSel} onChange={e=>setIpressSel(e.target.value)} disabled={loadIP} w={{ xs:'100%', sm:240 }}>
                        {ipress.map((ip,i)=><option key={i} value={ip.id_establecimiento}>{ip.nombre}</option>)}
                      </Sel>
                    : <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>IPRESS</Typography>
                        <Box className="pharmacy-layout" sx={{ height:34, px:1.5, display:'flex', alignItems:'center', border:`1px solid ${IOS.separator}`, borderRadius:'8px', bgcolor:IOS.bg, minWidth:{ xs:'100%', sm:240 } }}>
                          <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{ipress[0]?.nombre||'Cargando...'}</Typography>
                        </Box>
                      </Box>
                  }
                  <Sel label="Financiamiento" value={finan} onChange={e=>setFinan(e.target.value)} w={{ xs:'100%', sm:180 }}>
                    {FINANCIAMIENTOS.map(f=><option key={f.code} value={f.label}>{f.label}</option>)}
                  </Sel>
                  <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3, flex:1, minWidth:{ xs:'100%', sm:280 } }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Tipo / Nº Doc.</Typography>
                    <Box className="pharmacy-layout" sx={{ display:'flex', gap:1, alignItems:'center' }}>
                      <Sel value={tipodoc} onChange={e=>{setTipodoc(e.target.value);setDocumento('');}} w={90}>
                        {TIPOS_DOC.map(t=><option key={t.value} value={t.value}>{t.label}</option>)}
                      </Sel>
                      {tipodoc!=='3' && (
                        <input ref={inputRef} type="text"
                          placeholder={tipodoc==='2'?'Apellidos o nombre...':'Número de documento'}
                          value={documento} onChange={e=>setDocumento(e.target.value)}
                          onKeyDown={e=>e.key==='Enter'&&buscarRecetas()}
                          style={{ flex:1, height:34, padding:'0 10px', border:`1px solid ${IOS.separator}`, borderRadius:8,
                            fontSize:'0.8rem', color:IOS.label, backgroundColor:IOS.surface, outline:'none', fontFamily:'inherit' }}
                          onFocus={e=>e.target.style.borderColor=IOS.blue}
                          onBlur={e=>e.target.style.borderColor=IOS.separator} />
                      )}
                      <Box className="pharmacy-layout pharmacy-action" component="button" onClick={buscarRecetas} disabled={buscando}
                        sx={{ width:34, height:34, borderRadius:'10px', border:'none', flexShrink:0,
                          bgcolor:IOS.blue, cursor:buscando?'wait':'pointer', display:'flex',
                          alignItems:'center', justifyContent:'center', transition:'all 0.15s', '&:hover':{ filter:'brightness(0.9)' } }}>
                        {buscando?<CircularProgress size={14} sx={{ color:'white' }} />
                          :<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>}
                      </Box>
                      <Tooltip title="Nuevo estudio" placement="top">
                        <Box className="pharmacy-layout pharmacy-action" component="button" onClick={resetear}
                          sx={{ width:34, height:34, borderRadius:'10px', border:'none', flexShrink:0,
                            bgcolor:'#8E8E93', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center',
                            transition:'all 0.15s', '&:hover':{ filter:'brightness(0.9)' } }}>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                            <line x1="12" y1="12" x2="12" y2="18"/><line x1="9" y1="15" x2="15" y2="15"/>
                          </svg>
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {buscando && <Box sx={{ py:12, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}

              {!buscando && recetas.length===0 && !paciente && (
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                  <Box className="pharmacy-layout" sx={{ width:60, height:60, borderRadius:'50%', bgcolor:`${IOS.blue}12`,
                    display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                  </Box>
                  <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, mb:0.5 }}>Listo para buscar</Typography>
                  <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Selecciona los parámetros y presiona el botón buscar</Typography>
                </Box>
              )}

              {!buscando && recetas.length>0 && (
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                  <Box className="pharmacy-layout" sx={{ px:2.5, py:2, borderBottom:`1px solid ${IOS.separator}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <Box>
                      <Typography sx={{fontWeight:600,fontSize:'0.95rem',color:IOS.label,mb:0.3}}>Recetas encontradas</Typography>
                      <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
                        <Typography sx={{ fontSize:'0.78rem', color:IOS.label2 }}>
                          {recetas.length===1?'1 receta encontrada':`${recetas.length} recetas encontradas`}
                        </Typography>
                        {idEstudio && (
                          <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px', bgcolor:'#EDFAF2', border:'1px solid #B7EFD0' }}>
                            <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:IOS.green }} />
                            <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#1A6B3C' }}>Estudio activo</Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                    {!esSoloLect && <Box className="pharmacy-layout pharmacy-action" component="button" onClick={agregarTodas} disabled={guardando||buscando||recetas.every(r=>agregados.has(r.codigo))}
                      sx={{ height:34, px:2, borderRadius:'10px', border:'none', bgcolor:IOS.blue,
                        cursor:guardando?'wait':'pointer', display:'flex', alignItems:'center', gap:0.8,
                        transition:'all 0.15s', '&:hover':{ filter:'brightness(0.9)' } }}>
                      {guardando?<CircularProgress size={13} sx={{ color:'white' }} />
                        :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>}
                      <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>{guardando?'Guardando…':'Añadir pendientes ('+recetas.filter(r=>!agregados.has(r.codigo)).length+')'}</Typography>
                    </Box>}
                  </Box>
                  <div className="consumo-recipes-scroll"><table className="consumo-recipes"><thead><tr><th>Paciente / documento</th><th>Receta / establecimiento</th><th>Financiamiento / fecha</th><th>Total</th><th>Acciones</th></tr></thead><tbody>{recetas.map(r=>{const ya=agregados.has(r.codigo);return <tr key={r.codigo} className={ya?'is-selected':''}><td data-label="Paciente"><strong>{r.clides||'Paciente no informado'}</strong><small>{r.dni_clie||'Sin documento'}</small></td><td data-label="Receta"><strong>{r.serie}-{r.correlativo}</strong><small>{r.nombre}</small></td><td data-label="Atención"><span className="consumo-finance">{r.fpDescripcion||'Sin financiamiento'}</span><small>{fmtFecha(r.vtafechreg)}</small></td><td data-label="Total" className="consumo-money">{fmtS(r.vtatotal)}</td><td data-label="Acciones"><div className="consumo-row-actions integra-row-actions"><Tooltip title="Ver detalle" arrow><button type="button" aria-label="Ver detalle de la receta" onClick={()=>verDetalle(r)}><svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg></button></Tooltip>{!esSoloLect&&<Tooltip title={ya?'Quitar del estudio':'Añadir al estudio'} arrow><span><button type="button" aria-label={ya?'Quitar receta del estudio':'Añadir receta al estudio'} className={ya?'remove':'add'} disabled={guardando||buscando||!r.codigo} onClick={()=>ya?quitarReceta(r.codigo):agregarReceta(r)}><svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{ya?<><path d="M9 3h6l1 3H8l1-3ZM4 6h16M6 6l1 14h10l1-14M10 10v6M14 10v6"/></>:<><path d="M12 5v14M5 12h14"/></>}</svg></button></span></Tooltip>}{ya&&<button type="button" className={'consumo-go-study'+(recentlyAdded.has(r.codigo)?' is-new':'')} disabled={guardando||loadRes} onAnimationEnd={()=>setRecentlyAdded(prev=>{const next=new Set(prev);next.delete(r.codigo);return next;})} onClick={()=>{if(!mutationLock.current)setTab(2);}} aria-label={'Ir al estudio que incluye la receta '+r.serie+'-'+r.correlativo}><span>Ir al estudio</span><svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>}</div></td></tr>;})}</tbody></table></div>

                </Box>
              )}
            </Box>
          )}

          {/* ══ TAB 1: sin estudio ══ */}
          {tab===2 && !idEstudio && (
            <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
              <Box className="pharmacy-layout" sx={{ width:60, height:60, borderRadius:'50%', bgcolor:IOS.bg, display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="1.8" strokeLinecap="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                </svg>
              </Box>
              <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, mb:0.5 }}>Sin estudio activo</Typography>
              <Typography sx={{ color:IOS.label2, fontSize:'0.82rem', mb:2.5 }}>Ve a Buscar Recetas y agrega recetas al estudio</Typography>
              <Box className="pharmacy-action" component="button" onClick={()=>setTab(1)}
                sx={{ height:34, px:2.5, borderRadius:'10px', border:`1px solid ${IOS.blue}`,
                  bgcolor:'transparent', cursor:'pointer', color:IOS.blue, fontSize:'0.82rem', fontWeight:700 }}>
                Ir a buscar recetas
              </Box>
            </Box>
          )}

          {/* ══ TAB 1: con estudio ══ */}
          {tab===2 && idEstudio && (
            <Box>
              {/* KPIs */}
              <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'repeat(2,1fr)', md:'repeat(4,1fr)' }, gap:1.5, mb:2 }}>
                <KpiCard label="Total General" valor={fmtS(totalGeneral)} color={IOS.blue}
                  icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>} />
                <KpiCard label="Recetas" valor={cantRecetas} color={IOS.purple} sub="comprobantes"
                  icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="1.8" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>} />
                <KpiCard label="Medicamentos" valor={cantMeds} color={IOS.green} sub={fmtS(totalMeds)}
                  icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L18.5 2.5z"/><path d="M15 6l3 3"/></svg>} />
                <KpiCard label="Insumos" valor={cantInsumos} color={IOS.orange} sub={fmtS(totalInsumos)}
                  icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="1.8" strokeLinecap="round"><path d="M8.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.5"/><path d="M14 2.5v5a1 1 0 0 0 1 1h5"/><path d="M12 13v4M10 15h4"/></svg>} />
              </Box>

              {/* Info paciente + controles */}
              <Box className="pharmacy-layout pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', px:2.5, py:1.8, mb:2,
                boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`,
                display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:1.5 }}>
                <Box>
                  {paciente?.nombre && <Typography sx={{ fontWeight:800, fontSize:'0.95rem', color:IOS.blue, mb:0.3 }}>{paciente.nombre}</Typography>}
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:2, flexWrap:'wrap' }}>
                    {paciente?.dni && <Typography sx={{ fontSize:'0.73rem', color:IOS.label2 }}>DNI: <b style={{ color:IOS.label }}>{paciente.dni}</b></Typography>}
                    <Typography sx={{ fontSize:'0.73rem', color:IOS.label2 }}>Período: <b style={{ color:IOS.label }}>{filtrosEst?.fechaIni||fechaIni} — {filtrosEst?.fechaFin||fechaFin}</b></Typography>
                    <Typography sx={{ fontSize:'0.73rem', color:IOS.label2 }}>Financiamiento: <b style={{ color:IOS.label }}>{filtrosEst?.finan||finan}</b></Typography>
                  </Box>
                </Box>
                <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.5, bgcolor:IOS.bg, borderRadius:'12px', p:0.5 }}>
                    {['resumido','detallado'].map(v=>(
                      <Box key={v} onClick={()=>setVista(v)}
                        sx={{ px:2, py:0.7, borderRadius:'10px', cursor:'pointer',
                          bgcolor:vista===v?IOS.surface:'transparent',
                          boxShadow:vista===v?'0 1px 3px rgba(0,0,0,0.1)':'none', transition:'all 0.2s' }}>
                        <Typography sx={{ fontSize:'0.78rem', fontWeight:vista===v?700:500,
                          color:vista===v?IOS.label:IOS.label2, textTransform:'capitalize' }}>{v}</Typography>
                      </Box>
                    ))}
                  </Box>
                  <Box sx={{ width:'1px', height:24, bgcolor:IOS.separator, flexShrink:0 }} />
                  <Box className="pharmacy-layout pharmacy-action" aria-label="Descargar reporte" component="button" onClick={()=>setModalExp(true)} disabled={totalExp===0}
                    sx={{ width:32, height:32, borderRadius:'50%', border:'none',
                      bgcolor:totalExp===0?IOS.separator:IOS.green, cursor:totalExp===0?'default':'pointer',
                      display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s',
                      '&:hover':{ filter:totalExp===0?'none':'brightness(0.9)' } }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round">
                      <path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/>
                    </svg>
                  </Box>
                </Box>
                {!esSoloLect && recetasEstudio.length>0 && (
                  <Box className="pharmacy-layout" sx={{ width:'100%', pt:1.2, mt:0.3, borderTop:`1px dashed ${IOS.separator}`,
                    display:'flex', alignItems:'center', gap:1, flexWrap:'wrap' }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em', textTransform:'uppercase' }}>
                      Recetas en el estudio ({recetasEstudio.length}):
                    </Typography>
                    {recetasEstudio.map(rc=>(
                      <Box key={rc.codigo} sx={{ display:'inline-flex', alignItems:'center', gap:0.6, pl:1.2, pr:0.5, py:0.3,
                        borderRadius:'20px', bgcolor:IOS.bg, border:`1px solid ${IOS.separator}` }}>
                        <Typography sx={{ fontSize: '0.72rem', fontFamily:'monospace', color:IOS.label }}>{rc.comprobante}</Typography>
                        <Tooltip title="Quitar esta receta del estudio" placement="top">
                          <Box component="button" type="button" disabled={guardando} aria-label={'Quitar receta '+rc.comprobante} onClick={()=>quitarReceta(rc.codigo)}
                            sx={{ width:24, height:24, minWidth:24, padding:0, border:0, borderRadius:'50%', bgcolor:'#FEF2F2', display:'inline-flex', alignItems:'center',
                              justifyContent:'center', cursor:guardando?'wait':'pointer', transition:'all 0.15s',
                              '&:hover':{ bgcolor:'#DC2626', '& svg':{ stroke:'white' } } }}>
                            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round">
                              <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                            </svg>
                          </Box>
                        </Tooltip>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              {loadRes
                ? <Box sx={{ py:10, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>
                : <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                    {/* Móvil — cards */}
                    <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ display:{ xs:'block', md:'none' }, maxHeight:'calc(100vh - 380px)', overflowY:'auto' }}>
                      {(vista==='resumido'?resPag:detPag).map((r,i)=>(
                        <Box key={i} sx={{ p:2, borderBottom:`1px solid ${IOS.separator}` }}>
                          {vista==='detallado' && (
                            <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', gap:1, mb:0.3 }}>
                              <Typography sx={{ fontSize:'0.7rem', fontFamily:'monospace', color:IOS.label2 }}>{r.serie}-{r.correlativo} · Ítem {r.vtaItem}</Typography>
                              <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap' }}>{fmtFecha(r.vtafechreg)}</Typography>
                            </Box>
                          )}
                          <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:0.5 }}>
                            <Typography sx={{ fontWeight:600, fontSize:'0.78rem', color:IOS.label, flex:1 }}>{r.producto}</Typography>
                            <TipoPill tipo={r.fM_medtip} />
                          </Box>
                          <Typography sx={{ fontSize: '0.72rem', fontFamily:'monospace', color:IOS.label2, mb:1 }}>
                            {r.medCod}{vista==='detallado' ? ` · ${r.nombre}${r.medLote?` · Lote: ${r.medLote}`:''}` : ''}
                          </Typography>
                          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:0.8 }}>
                            {[['Prescrito',r.cantidad_Vendida],['Devuelto',r.cantidad_Devuelta],['Entregado',r.cantidad_Neta],['Total',Number(r.total_Neto||0).toFixed(2)]].map(([l,v],j)=>(
                              <Box key={j} sx={{ bgcolor:IOS.bg, borderRadius:'10px', px:0.5, py:0.6, textAlign:'center' }}>
                                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textTransform:'uppercase' }}>{l}</Typography>
                                <Typography sx={{ fontSize:'0.78rem', fontWeight:j===3?800:600, color:j===3?IOS.blue:IOS.label }}>{v}</Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      ))}
                    </Box>
                    {/* Desktop — tablas */}
                    <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto', overflowY:'auto', maxHeight:'calc(100vh - 440px)',
                      '&::-webkit-scrollbar':{ width:4, height:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>

                      {/* ── Vista resumida ── */}
                      {vista==='resumido' && (
                        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem', minWidth:680 }}>
                          <thead>
                            <tr>
                              {['Código','Producto','Tipo','Prescrito','Devuelto','Entregado','Total'].map((h,i)=>(
                                <th key={i} style={{ padding:'9px 12px', textAlign:i>=3?'right':i===2?'center':'left',
                                  fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em', textTransform:'uppercase',
                                  backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`, position:'sticky', top:0, whiteSpace:'nowrap', zIndex:1 }}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {resPag.map((r,i)=>(
                              <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface, transition:'background 0.1s' }}
                                onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                                onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                                <td style={{ padding:'8px 12px', fontFamily:'monospace', fontSize:'0.7rem', color:IOS.label2 }}>{r.medCod}</td>
                                <td style={{ padding:'8px 12px', maxWidth:300 }}>
                                  <Tooltip title={r.producto} placement="top">
                                    <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:300, color:IOS.label }}>{r.producto}</span>
                                  </Tooltip>
                                </td>
                                <td style={{ padding:'8px 12px', textAlign:'center' }}><TipoPill tipo={r.fM_medtip} /></td>
                                <td style={{ padding:'8px 12px', textAlign:'right', color:IOS.label }}>{r.cantidad_Vendida}</td>
                                <td style={{ padding:'8px 12px', textAlign:'right', color:IOS.label }}>{r.cantidad_Devuelta}</td>
                                <td style={{ padding:'8px 12px', textAlign:'right', fontWeight:600, color:IOS.label }}>{r.cantidad_Neta}</td>
                                <td style={{ padding:'8px 12px', textAlign:'right', fontWeight:800, color:IOS.label }}>{Number(r.total_Neto||0).toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr>
                              <TF colSpan={3}>Totales — {resumido.length} productos</TF>
                              <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totResumido.vendida.toFixed(0)}</span></TF>
                              <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totResumido.devuelta.toFixed(0)}</span></TF>
                              <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totResumido.neta.toFixed(0)}</span></TF>
                              <TF right><span style={{ color:IOS.blue, fontWeight:800, fontSize:'0.88rem' }}>{totResumido.total.toFixed(2)}</span></TF>
                            </tr>
                          </tfoot>
                        </table>
                      )}

                      {/* ── Vista detallada ── */}
                      {vista==='detallado' && (
                        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.73rem', minWidth:1100 }}>
                          <thead>
                            <tr>
                              {['Serie-Nº','IPRESS','Fecha','Ítem','Código','Producto','T','Reg.San','Lote','Prescrito','Devuelto','Entregado','Precio','Tot.Presc.','Tot.Dev.','Total'].map((h,i)=>(
                                <th key={i} style={{ padding:'9px 8px', textAlign:i>=10?'right':i===7?'center':'left',
                                  fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em', textTransform:'uppercase',
                                  backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`, position:'sticky', top:0, whiteSpace:'nowrap', zIndex:1 }}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {detPag.map((r,i)=>(
                              <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface, transition:'background 0.1s' }}
                                onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                                onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                                
                                <td style={{ padding:'7px 8px', fontFamily:'monospace', fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap' }}>{r.serie}-{r.correlativo}</td>
                                <td style={{ padding:'7px 8px', maxWidth:120 }}><span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:120, fontSize: '0.72rem', color:IOS.label }}>{r.nombre}</span></td>
                                <td style={{ padding:'7px 8px', fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap' }}>{fmtFecha(r.vtafechreg)}</td>
                                <td style={{ padding:'7px 8px', textAlign:'center', fontSize: '0.72rem', color:IOS.label }}>{r.vtaItem}</td>
                                <td style={{ padding:'7px 8px', fontFamily:'monospace', fontSize: '0.72rem', color:IOS.label2 }}>{r.medCod}</td>
                                <td style={{ padding:'7px 8px', maxWidth:180 }}>
                                  <Tooltip title={r.producto} placement="top">
                                    <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:180, fontSize: '0.72rem', color:IOS.label }}>{r.producto}</span>
                                  </Tooltip>
                                </td>
                                <td style={{ padding:'7px 8px', textAlign:'center' }}><TipoPill tipo={r.fM_medtip} /></td>
                                <td style={{ padding:'7px 8px', fontSize: '0.72rem', color:IOS.label }}>{r.medRegSan}</td>
                                <td style={{ padding:'7px 8px', fontSize: '0.72rem', color:IOS.label }}>{r.medLote}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{r.cantidad_Vendida}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{r.cantidad_Devuelta}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', fontWeight:600, color:IOS.label }}>{r.cantidad_Neta}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{Number(r.vtaPrecio||0).toFixed(2)}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{Number(r.vtaImporte||0).toFixed(2)}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{Number(r.total_Devuelto||0).toFixed(2)}</td>
                                <td style={{ padding:'7px 8px', textAlign:'right', fontWeight:800, color:IOS.label }}>{Number(r.total_Neto||0).toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                 <tfoot>
                            <tr>
                              <TF colSpan={9}>Totales — {detallado.length} ítems</TF>
                              <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totDetallado.vendida.toFixed(0)}</span></TF>
                              <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totDetallado.devuelta.toFixed(0)}</span></TF>
                              <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totDetallado.neta.toFixed(0)}</span></TF>
                              <TF colSpan={3} right></TF>
                              <TF right><span style={{ color:IOS.blue, fontWeight:800, fontSize:'0.88rem' }}>{totDetallado.total.toFixed(2)}</span></TF>
                            </tr>
                          </tfoot>
                        </table>
                      )}
                    </Box>
                    {vista==='resumido'
                      ? <Paginacion total={resumido.length} pagina={pgRes} setPagina={setPgRes} rpp={rppRes} setRpp={setRppRes} />
                      : <Paginacion total={detallado.length} pagina={pgDet} setPagina={setPgDet} rpp={rppDet} setRpp={setRppDet} />
                    }
                  </Box>
              }
            </Box>
          )}

          {/* ══ TAB 3: Consulta Masiva (solo Total) ══ */}
          {tab===3 && esTOTAL && (
            <Box>
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2.5,
                boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2.5 }}>
                <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-end' }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Período</Typography>
                    <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1 }}>
                      <DatePickerIOS value={mIni} onChange={setMIni} w={{ xs:'calc(50% - 4px)', sm:130 }} />
                      <DatePickerIOS value={mFin} onChange={setMFin} w={{ xs:'calc(50% - 4px)', sm:130 }} />
                    </Box>
                  </Box>
                  <Sel label="IPRESS" value={mIpress} onChange={e=>setMIpress(e.target.value)} disabled={loadIP} w={{ xs:'100%', sm:240 }}>
                    {ipress.map((ip,i)=><option key={i} value={ip.id_establecimiento}>{ip.nombre}</option>)}
                  </Sel>
                  <Sel label="Financiamiento" value={mFinan} onChange={e=>setMFinan(e.target.value)} w={{ xs:'100%', sm:180 }}>
                    {FINANCIAMIENTOS.map(f=><option key={f.code} value={f.label}>{f.label}</option>)}
                  </Sel>
                  <Box className="pharmacy-layout pharmacy-action" component="button" onClick={buscarMasivo} disabled={loadMas||limMasivo}
                    sx={{ height:34, px:2, borderRadius:'10px', border:'none', bgcolor:limMasivo?IOS.separator:IOS.blue,
                      cursor:limMasivo?'default':loadMas?'wait':'pointer', display:'flex', alignItems:'center', gap:0.8,
                      transition:'all 0.15s', '&:hover':{ filter:'brightness(0.9)' } }}>
                    {loadMas?<CircularProgress size={13} sx={{ color:'white' }} />
                      :<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>}
                    <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>{loadMas?'Consultando…':'Consultar'}</Typography>
                  </Box>
                  <Box className="pharmacy-layout pharmacy-action" component="button" onClick={exportarMasivoExcel} disabled={masivo.length===0||exportando}
                    sx={{ height:34, px:1.8, borderRadius:'10px',
                      border:`1px solid ${masivo.length===0?IOS.separator:'#059669'}`,
                      bgcolor:masivo.length===0?IOS.bg:'#D1FAE5',
                      cursor:masivo.length===0?'default':exportando?'wait':'pointer',
                      display:'flex', alignItems:'center', gap:0.8, transition:'all 0.2s',
                      opacity:masivo.length===0?0.5:1,
                      '&:hover':{ bgcolor:masivo.length===0?IOS.bg:'#A7F3D0', transform:masivo.length===0?'none':'translateY(-1px)',
                        boxShadow:masivo.length===0?'none':'0 4px 12px #05966925' } }}>
                    {exportando
                      ? <CircularProgress size={13} sx={{ color:'#059669' }} />
                      : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={masivo.length===0?IOS.label2:'#059669'} strokeWidth="1.8" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/><line x1="12" y1="10" x2="12" y2="20"/></svg>}
                    <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:masivo.length===0?IOS.label2:'#047857' }}>
                      {exportando?'Generando…':'Exportar Excel'}
                    </Typography>
                    {masivo.length>0 && !exportando && (
                      <Box sx={{ px:0.7, py:0.1, borderRadius:'10px', bgcolor:'#059669' }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'white' }}>{masivo.length.toLocaleString()}</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
                {limMasivo && (
                  <Box className="pharmacy-layout" sx={{ mt:1.5, px:1.5, py:1, borderRadius:'10px', bgcolor:'#FEF2F2', border:'1px solid #FECACA',
                    display:'flex', alignItems:'center', gap:1 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                    <Typography sx={{ fontSize:'0.75rem', color:'#B91C1C', fontWeight:600 }}>
                      El período máximo de consulta es de 3 meses. Ajusta las fechas para continuar.
                    </Typography>
                  </Box>
                )}
                {!limMasivo && rangoMasivoLargo && (
                  <Box className="pharmacy-layout" sx={{ mt:1.5, px:1.5, py:1, borderRadius:'10px', bgcolor:'#FFF7E6', border:'1px solid #FED7AA',
                    display:'flex', alignItems:'center', gap:1 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    <Typography sx={{ fontSize:'0.75rem', color:'#92400E', fontWeight:600 }}>
                      El período seleccionado supera los 2 meses — el resultado puede demorar unos segundos.
                    </Typography>
                  </Box>
                )}
              </Box>

              {loadMas && <Box sx={{ py:12, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}

              {!loadMas && masivo.length===0 && (
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                  <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, mb:0.5 }}>
                    {buscoMas?'Sin resultados':'Consulta masiva de consumo'}
                  </Typography>
                  <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>
                    {buscoMas?'No se encontraron ventas en ese rango':'Selecciona el período y presiona Consultar'}
                  </Typography>
                </Box>
              )}

              {!loadMas && masivo.length>0 && (
                <>
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2,
                  boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2 }}>
                  <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:1.5, flexWrap:'wrap', alignItems:'flex-end' }}>
                    <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3, flex:1, minWidth:{ xs:'100%', sm:220 } }}>
                      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Buscar en resultados</Typography>
                      <input type="text" placeholder="DNI, nombre o serie-correlativo..."
                        value={fMasTxt} onChange={e=>{setFMasTxt(e.target.value);setPgMas(1);}}
                        style={{ height:34, padding:'0 10px', border:`1px solid ${IOS.separator}`, borderRadius:8,
                          fontSize:'0.8rem', color:IOS.label, backgroundColor:IOS.surface, outline:'none', fontFamily:'inherit' }}
                        onFocus={e=>e.target.style.borderColor=IOS.blue}
                        onBlur={e=>e.target.style.borderColor=IOS.separator} />
                    </Box>
                    <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Fecha</Typography>
                      <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
                        <DatePickerIOS value={fMasFecha} onChange={v=>{setFMasFecha(v);setPgMas(1);}} w={130} />
                        {fMasFecha && (
                          <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>{setFMasFecha('');setPgMas(1);}}
                            sx={{ width:24, height:24, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA',
                              cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
                              '&:hover':{ bgcolor:'#D1D1D6' } }}>
                            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <Sel label="F. Pago" value={fMasFp} onChange={e=>{setFMasFp(e.target.value);setPgMas(1);}} w={{ xs:'calc(50% - 6px)', sm:160 }}>
                      {fpsMasivo.map(fp=><option key={fp} value={fp}>{fp}</option>)}
                    </Sel>
                    <Sel label="Farmacia" value={fMasFarm} onChange={e=>{setFMasFarm(e.target.value);setPgMas(1);}} w={{ xs:'calc(50% - 6px)', sm:200 }}>
                      {farmsMasivo.map(f=><option key={f} value={f}>{f}</option>)}
                    </Sel>
                    <Typography sx={{ fontSize:'0.75rem', color:IOS.label2, pb:0.8, whiteSpace:'nowrap' }}>
                      {masivoFiltrado.length.toLocaleString()} de {masivo.length.toLocaleString()}
                    </Typography>
                  </Box>
                </Box>
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                  {/* Móvil — cards */}
                  <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ display:{ xs:'block', md:'none' }, maxHeight:'calc(100vh - 320px)', overflowY:'auto' }}>
                    {masPag.map((r,i)=>(
                      <Box key={i} sx={{ p:2, borderBottom:`1px solid ${IOS.separator}` }}>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', gap:1, mb:0.3 }}>
                          <Typography sx={{ fontWeight:700, fontSize:'0.78rem', color:IOS.blue, flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{r.paciente}</Typography>
                          <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap' }}>{r.fecha}</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '0.72rem', fontFamily:'monospace', color:IOS.label2, mb:0.8 }}>DNI: {r.dni} · {r.comprobante}</Typography>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:0.3 }}>
                          <Typography sx={{ fontWeight:600, fontSize:'0.75rem', color:IOS.label, flex:1 }}>{r.producto}</Typography>
                          <TipoPill tipo={r.tipo} />
                        </Box>
                        <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, mb:1 }}>{r.formaPago} · {r.farmacia}</Typography>
                        <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:0.8 }}>
                          {[['Cantidad',r.cantidad],['Dispensado',r.dispensado],['Precio',Number(r.precio||0).toFixed(2)],['Importe',Number(r.importe||0).toFixed(2)]].map(([l,v],j)=>(
                            <Box key={j} sx={{ bgcolor:IOS.bg, borderRadius:'10px', px:0.5, py:0.6, textAlign:'center' }}>
                              <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textTransform:'uppercase' }}>{l}</Typography>
                              <Typography sx={{ fontSize:'0.76rem', fontWeight:j===3?800:600, color:j===3?IOS.blue:IOS.label }}>{v}</Typography>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  {/* Desktop — tabla */}
                  <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto', overflowY:'auto', maxHeight:'calc(100vh - 380px)',
                    '&::-webkit-scrollbar':{ width:4, height:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.73rem', minWidth:1050 }}>
                      <thead>
                        <tr>
                          {['Fecha','Comprobante','DNI','Paciente','F. Pago','Código','Medicamento','T','Cantidad','Devuelto','Dispensado','Farmacia','Precio','Importe'].map((h,i)=>(
                            <th key={i} style={{ padding:'9px 8px', textAlign:i>=8&&i<=10||i>=12?'right':i===7?'center':'left',
                              fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em', textTransform:'uppercase',
                              backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`, position:'sticky', top:0, whiteSpace:'nowrap', zIndex:1 }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {masPag.map((r,i)=>(
                          <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface, transition:'background 0.1s' }}
                            onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                            onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                            <td style={{ padding:'7px 8px', fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap' }}>{r.fecha}</td>
                            <td style={{ padding:'7px 8px', fontFamily:'monospace', fontSize: '0.72rem', color:IOS.label2, whiteSpace:'nowrap' }}>{r.comprobante}</td>
                            <td style={{ padding:'7px 8px', fontFamily:'monospace', fontSize: '0.72rem', color:IOS.label2 }}>{r.dni}</td>
                            <td style={{ padding:'7px 8px', maxWidth:170 }}><span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:170, fontSize: '0.72rem', color:IOS.label, fontWeight:600 }}>{r.paciente}</span></td>
                            <td style={{ padding:'7px 8px', fontSize: '0.72rem', color:IOS.label }}>{r.formaPago}</td>
                            <td style={{ padding:'7px 8px', fontFamily:'monospace', fontSize: '0.72rem', color:IOS.label2 }}>{r.medCod}</td>
                            <td style={{ padding:'7px 8px', maxWidth:200 }}>
                              <Tooltip title={r.producto} placement="top">
                                <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:200, fontSize: '0.72rem', color:IOS.label }}>{r.producto}</span>
                              </Tooltip>
                            </td>
                            <td style={{ padding:'7px 8px', textAlign:'center' }}><TipoPill tipo={r.tipo} /></td>
                            <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{r.cantidad}</td>
                            <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{r.devuelto}</td>
                            <td style={{ padding:'7px 8px', textAlign:'right', fontWeight:600, color:IOS.label }}>{r.dispensado}</td>
                            <td style={{ padding:'7px 8px', maxWidth:140 }}><span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:140, fontSize: '0.72rem', color:IOS.label2 }}>{r.farmacia}</span></td>
                            <td style={{ padding:'7px 8px', textAlign:'right', color:IOS.label }}>{Number(r.precio||0).toFixed(2)}</td>
                            <td style={{ padding:'7px 8px', textAlign:'right', fontWeight:800, color:IOS.label }}>{Number(r.importe||0).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <TF colSpan={8}>Totales — {masivoFiltrado.length} ítems</TF>
                          <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totMasivo.cantidad.toFixed(0)}</span></TF>
                          <TF right><span style={{ color:IOS.label, fontWeight:800 }}>0</span></TF>
                          <TF right><span style={{ color:IOS.label, fontWeight:800 }}>{totMasivo.cantidad.toFixed(0)}</span></TF>
                          <TF colSpan={2} right></TF>
                          <TF right><span style={{ color:IOS.blue, fontWeight:800, fontSize:'0.88rem' }}>{totMasivo.importe.toFixed(2)}</span></TF>
                        </tr>
                      </tfoot>
                    </table>
                  </Box>
                  <Paginacion total={masivoFiltrado.length} pagina={pgMas} setPagina={setPgMas} rpp={rppMas} setRpp={setRppMas} />
                </Box>
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* Modal selector formato */}
      <ModalExportar
        open={modalExp}
        onClose={()=>setModalExp(false)}
        total={totalExp}
        onVerPdf={verPdf}
        onExportarExcel={exportarExcel}
        exportando={exportando}
      />

      {/* Modal visor PDF */}
      <ModalPdfVisor
        open={modalPdf}
        onClose={closePdf}
        pdfUrl={pdfUrl}
        cargando={cargPdf}
        titulo={`Consumo Paciente — ${vista.charAt(0).toUpperCase()+vista.slice(1)}`}
        subtitulo={paciente?.nombre ? `${paciente.nombre}${paciente?.dni?' · DNI: '+paciente.dni:''}` : ''}
        nombreDescarga={`ConsumoP_${paciente?.dni||'reporte'}_${vista}.pdf`}
      />

      {/* Modal detalle receta */}
      <ModalDetalle open={modalDet} onClose={()=>{detailSeq.current++;setModalDet(false);}} error={detailError} receta={recetaSel} detalle={detalleRec} cargando={loadDet} />
    </>
  );
};

export default ConsumoPaciente;
